import { FC } from "react";
import { TranslationUpdaterItem } from "./TranslationUpdaterItem";
import { IEnvironment } from "../../../interfaces";

interface Props {
  envs: IEnvironment[];
  updatingState: Record<string, boolean>;
  disableState: Record<string, boolean>;
  version: "internal" | "external";
  onUpdateInternalEnvClick: (env: IEnvironment) => void;
  onUpdateProdEnvClick: (env: IEnvironment) => void;
}

export const TranslationUpdaterList: FC<Props> = ({
  envs,
  updatingState,
  disableState,
  version,
  onUpdateProdEnvClick,
  onUpdateInternalEnvClick,
}) => {
  return (
    <>
      {envs?.map((env) => (
        <TranslationUpdaterItem
          key={env?.name}
          env={env}
          isUpdating={updatingState[env?.name]}
          isDisabled={disableState[env?.name]}
          version={version}
          onUpdateInternalClick={onUpdateInternalEnvClick}
          onUpdateProdClick={onUpdateProdEnvClick}
        />
      ))}
    </>
  );
};
